export const PORTAL_LOADING_APP_FAILURE = 'PORTAL_LOADING_APP_FAILURE';
export const PORTAL_LOADING_APP_REQUEST = 'PORTAL_LOADING_APP_REQUEST';
export const PORTAL_LOADING_APP_SUCCESS = 'PORTAL_LOADING_APP_SUCCESS';
export const PORTAL_SET_PARAM = 'PORTAL_SET_PARAM';
